import * as yup from "yup";
import { Language } from "../../../language/English";
export const NoteValidation = () => {
    return yup.object().shape({
        note : yup.string().min(1).max(1000).required().label(Language.NOTE),
    });
}